import { useUserInfo } from '@/services/userService'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './LayoutHeaderPc.module.less'
import cls from 'classnames'
import { commonUtils } from '@/helpers/commonUtils'
import LanguageSwitcher from '@/components/LanguageSwitcher/LanguageSwitcher'
import { Link } from 'react-router-dom'
import MiddleText from '@/components/MiddleText/MiddleText'
import { getProductDashboardLink, PAGE_LINKS } from '@/router/pageConst'
import ResourceBtn from '@/components/ResourceBtn/ResourceBtn'
import ProductEntryBtn from '@/components/ProductEntryBtn/ProductEntryBtn'
import NiceModal from '@ebay/nice-modal-react'
import ProductSwitchModal from '@/components/Modals/ProductSwitchModal/ProductSwitchModal'
// import { INTERNAL_HOST } from '@/commonConst'

interface Pros {
  scrollTop: number
}

function LayoutHeaderPc({ scrollTop }: Pros) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const userInfo = useUserInfo()
  const [hasUserInfo, setHasUserInfo] = useState<boolean>(false)

  useEffect(() => {
    const one: boolean = Boolean(userInfo)
    const two: boolean = !userInfo?.isExpert
    setHasUserInfo(one && two)
  }, [userInfo])

  const handleDashboardClick = () => {
    NiceModal.show(ProductSwitchModal, {
      productType: 'horizontal-base',
      onSelectProduct: (productType: ProjectModels.ProjectCategory) => {
        navigate(getProductDashboardLink(productType, 'project'))
      },
    })
  }

  return (
    <div className={cls(styles.layoutHeader, { [styles.scrolling]: scrollTop > 0 })} data-testid='layout-header-pc'>
      <div className={styles.headerContent}>
        <div className={styles.brandBox}>
          <img
            data-testid='page-header-logo-link'
            className={styles.brand}
            src={commonUtils.getImagePath('homePage/adeff-logo.png')}
            alt=''
            onClick={() => {
              navigate(PAGE_LINKS.index)
            }}
          />
        </div>
        <div className={styles.options}>
          <LanguageSwitcher />
          <ProductEntryBtn />
          <Link to={PAGE_LINKS.contact} style={{ textDecoration: 'none' }}>
            <div className={styles.option} data-testid='page-header-contact-link'>{t('pageHeader.contactUs')}</div>
          </Link>
          <Link to={PAGE_LINKS.pricing} style={{ textDecoration: 'none' }}>
            <div className={styles.option} data-testid='page-header-pricing-link'>{t('pageHeader.Pricing')}</div>
          </Link>
          <ResourceBtn className={styles.option} />
          {!hasUserInfo && (
            <Link
              to={PAGE_LINKS.login}
              state={{ mode: 'login' }}
              style={{ textDecoration: 'none' }}
            >
              <div className={styles.option} data-testid='page-header-sign-in-link'>{t('pageHeader.signIn')}</div>
            </Link>
          )}
          {hasUserInfo ? (
            <button type='button' className={styles.btn} onClick={handleDashboardClick} data-testid='page-header-dashboard-btn'>
              <MiddleText text={t('pageHeader.Dashboard')} />
            </button>
          ) : (
            <Link to={PAGE_LINKS.login} state={{ mode: 'sign' }} style={{ textDecoration: 'none' }}>
              <button className={styles.btn} data-testid='page-header-sign-up-btn'>
                <MiddleText text={t('pageHeader.signUp')} />
              </button>
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

export default observer(LayoutHeaderPc)
